<template>
  <div class="contrato-container">
    <div class="header-section">
      <div class="logo-area logo-left">
        <img :src="logoSuape" alt="Logo SUAPE" class="img-fluid logo-img" />
      </div>
      <div class="title-center">
        MEMÓRIA DE CÁLCULO
      </div>
      <div class="logo-area logo-right">
        <img v-if="dados.logoFornecedorUrl" :src="dados.logoFornecedorUrl" alt="Logo Contratada" class="img-fluid logo-img" />
        <div v-else class="box-placeholder">
          Logomarca da empresa<br>(consórcio) contratada
        </div>
      </div>
    </div>

    <div class="data-table">
      <div class="table-row">
        <div class="cell full-col">
          <span class="label">CONTRATO:</span>
          <span class="value">{{ dados.numeroContrato }}</span>
        </div>
      </div>

      <div class="table-row">
        <div class="cell full-col">
          <span class="label">CONTRATADA:</span>
          <span class="value">{{ dados.contratada }}</span>
        </div>
      </div>

      <div class="table-row">
        <div class="cell full-col">
          <span class="label">OBJETO:</span>
          <span class="value object-text">{{ dados.objeto }}</span>
        </div>
      </div>

      <div class="table-row">
        <div class="cell full-col">
          <span class="label">MEDIÇÃO:</span>
          <span class="value">{{ dados.medicao }}</span>
        </div>
      </div>

      <div class="table-row">
        <div class="cell full-col">
          <span class="label">PERÍODO:</span>
          <span class="value">{{ dados.periodo }}</span>
        </div>
      </div>

    </div>

    <div class="content-slot mt-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            required: true
        },
        boletimMedicao: {
            type: Object,
            required: true
        },
        valorTotalTodosBoletins: {
            type: Number,
            required: false
        },
        fornecedorLogoUrl: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            logoSuape: '/img/logo.png',
            valorTotalBoletinsPersistido: 0
        }
    },
    methods: {
        formatarDataPeriodo(data) {
            if (!data) return ''
            const dataFormatada = this.$moment(data)
            if (!dataFormatada.isValid() || dataFormatada.year() <= 1) return ''
            return dataFormatada.format('DD/MM/YYYY')
        },
        obterPeriodoBoletim() {
            const inicio = this.formatarDataPeriodo(this.boletimMedicao.dataInicio)
            const fim = this.formatarDataPeriodo(this.boletimMedicao.dataFim)

            if (inicio && fim) return `${inicio} - ${fim}`
            if (inicio) return inicio
            if (fim) return fim

            return this.boletimMedicao.competencia
                ? `${this.$moment(this.boletimMedicao.competencia).startOf('month').format('DD/MM/YYYY')} - ${this.$moment(this.boletimMedicao.competencia).endOf('month').format('DD/MM/YYYY')}`
                : ''
        }
    },
    computed: {
        valorTotalBoletinsComputado() {
            if (this.valorTotalTodosBoletins !== undefined && this.valorTotalTodosBoletins !== null) {
                return this.valorTotalTodosBoletins;
            }
            return this.valorTotalBoletinsPersistido;
        },
        chaveLocalStorage() {
            return `valorTotalBoletins_${this.contrato.codContrato}_${this.boletimMedicao.id}`;
        },
        dados() {
            return {
                numeroContrato: this.contrato.codContrato,
                contratada: this.contrato.fornecedor ? (`${this.contrato.fornecedor.cnpj} - ${this.contrato.fornecedor.nome}`) : '',
                ordemServico: '-',
                objeto: this.contrato.objeto,
                medicao: this.boletimMedicao.numero,
                periodo: this.obterPeriodoBoletim(),
                valorContrato: this.contrato.valorTotal || 0,
                valorMedicao: this.boletimMedicao.total || 0,
                totalMedido: this.valorTotalBoletinsComputado || 0,
                saldoContratual: (this.contrato.valorTotal || 0) - (this.valorTotalBoletinsComputado || 0),
                logoFornecedorUrl: this.fornecedorLogoUrl
            }
        }
    },
    watch: {
        valorTotalTodosBoletins: {
            immediate: true,
            handler(newVal) {
                if (newVal !== undefined && newVal !== null) {
                    localStorage.setItem(this.chaveLocalStorage, newVal.toString());
                    this.valorTotalBoletinsPersistido = newVal;
                }
            }
        }
    },
    mounted() {
        const valorSalvo = localStorage.getItem(this.chaveLocalStorage);
        if (valorSalvo !== null) {
            this.valorTotalBoletinsPersistido = parseFloat(valorSalvo);
        }
    },
    filters: {
        currency(value) {
            if (value === null || value === undefined) return 'R$ 0,00'
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }
    }
}
</script>

<style scoped>
.resumo-container {
    font-family: Arial, Helvetica, sans-serif;
    color: #000;
    width: 100%;
    background: #fff;
}

.header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    margin-bottom: 5px;
    min-height: 80px;
}

.logo-area {
    width: 20%;
    display: flex;
    align-items: center;
}

.logo-left {
    justify-content: flex-start;
}

.logo-right {
    justify-content: flex-end;
}

.logo-img {
    max-width: 100%;
    max-height: 70px;
    object-fit: contain;
}

.title-center {
    flex-grow: 1;
    text-align: center;
    font-weight: bold;
    font-size: 1.2rem;
    text-transform: uppercase;
}

.box-placeholder {
    border: 1px solid #000;
    padding: 5px;
    font-weight: bold;
    text-align: center;
    font-size: 0.8rem;
    width: 100%;
}

.data-table {
    border: 1px solid #000;
    display: flex;
    flex-direction: column;
}

.table-row {
    display: flex;
    border-bottom: 1px solid #000;
}

.table-row:last-child {
    border-bottom: none;
}

.cell {
    padding: 2px 5px;
    display: flex;
    align-items: center;
    font-size: 0.85rem;
}

.left-col-full { /* Adjusted for single column layout */
    width: 100%;
    display: flex;
    align-items: center;
}

.label {
    font-weight: 800;
    text-transform: uppercase;
    margin-right: 5px;
    white-space: nowrap;
}

.value {
    font-weight: 700;
    flex-grow: 1;
}

.object-text {
    white-space: normal;
    line-height: 1.2;
}
</style>

<style scoped>
.contrato-container {
  font-family: Arial, Helvetica, sans-serif;
  color: #000;
  width: 100%;
  background: #fff;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  margin-bottom: 5px;
  min-height: 80px;
}

.logo-area { width: 20%; display: flex; align-items: center; }
.logo-left { justify-content: flex-start; }
.logo-right { justify-content: flex-end; }
.logo-img { max-width: 100%; max-height: 100px; object-fit: contain; }
.title-center { flex-grow: 1; text-align: center; font-weight: 600; font-size: 1.2rem; text-transform: uppercase; }
.box-placeholder { border: 1px solid #000; padding: 5px; font-weight: 500; text-align: center; font-size: 0.8rem; width: 100%; }

.data-table {
  border: 1px solid #000;
  display: flex;
  flex-direction: column;
}

.table-row {
  display: flex;
  border-bottom: 1px solid #000;
}

.table-row:last-child {
  border-bottom: none;
}

.cell {
  padding: 2px 5px;
  display: flex;
  align-items: center;
  font-size: 0.85rem;
}

.full-col {
  width: 100%;
}

.label {
  font-weight: 600;
  text-transform: uppercase;
  margin-right: 5px;
  white-space: nowrap;
}

.value {
  font-weight: 400;
  flex-grow: 1;
}

.object-text {
  white-space: normal;
  line-height: 1.2;
}
</style>
